import { createAction, props } from '@ngrx/store';
import { Meeting } from '../../meeting';
import { MeetingCheckInSteps } from '../../meeting-check-in-steps';

export const loadMeeting = createAction(
  '[MeetingAttendees] Load Meeting',
  props<{ meetingId?: number, email?: string }>()
);

export const loadMeetingSuccess = createAction(
  '[MeetingAttendees] Load Meeting Success',
  props<{ meeting: Meeting }>()
);

export const loadMeetingFailure = createAction(
  '[MeetingAttendees] Load Meeting Failure',
  props<{ error: any }>()
);

export const goToStep = createAction(
  '[MeetingAttendees] Meeting Selected',
  props<{ step: MeetingCheckInSteps }>()
);

export const checkedIn = createAction(
  '[MeetingAttendees] Check In Successful'
);

export const clearStore = createAction(
  '[MeetingAttendees] Clear store'
);